var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H13V5C13 4.4 12.6 4 12 4C11.4 4 11 4.4 11 5V11H5C4.4 11 4 11.4 4 12C4 12.6 4.4 13 5 13H11V19C11 19.6 11.4 20 12 20C12.6 20 13 19.6 13 19V13H19C19.6 13 20 12.6 20 12C20 11.4 19.6 11 19 11Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPlus.b63519b0bc4314b66704d1570bf8a8ca.svg";